exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heHxcDMS0dhm_m{float:left}._1SEz0cJPMzGn3-{margin-left:-2px;float:right;position:relative}._18HOmBqwfZvsdp{display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(0,0,0,.2);font-size:12px;color:#172b4d;float:right;margin-left:-2px}._30ppd9kx6Q4f0o{cursor:pointer;transition:background .3s ease}._30ppd9kx6Q4f0o:hover{background:rgba(0,0,0,.4)}", ""]);

// exports
exports.locals = {
	"facepile": "heHxcDMS0dhm_m",
	"avatar": "_1SEz0cJPMzGn3-",
	"showMore": "_18HOmBqwfZvsdp",
	"showMoreClickable": "_30ppd9kx6Q4f0o"
};